// Needs slick.js jquery slider

(function($) {

	//
	// Default options
	//
	var defaultOptions = {
		slidesToShow: 1,
		responsive: null,
		scrollTo: null,
		disableNavigation: false,
	};

	//
	// Timeliner class
	//
	function Timeliner(timelinerElement, options) {
		this.$timeliner = $(timelinerElement);
		this.$navigation = this.$timeliner.find(".timeliner-navigation");
		this.$content = this.$timeliner.find(".timeliner-content");
		this.options = options;

		if (this.$navigation.length == 0) {
			this.$navigation = null;
			this.options.disableNavigation = true;
		}
	}
	Timeliner.prototype = {
		constructor: Timeliner,

		ready: function() {
			// Activate content
			this.$content.slick({
				infinite: false,
				arrows: false,
				adaptiveHeight: true,
				asNavFor: this.$navigation,
			});

			// Activate navigation
			if (!this.options.disableNavigation) {
				this.$navigation.slickExt({
					infinite: false,
					slidesToShow: this.options.slidesToShow,
					slidesToScroll: 1,
					focusOnSelect: true,
					asNavFor: this.$content,
					prevArrow: '<button type="button" class="slick-prev"></button>',
					nextArrow: '<button type="button" class="slick-next"></button>',
					swipeToSlide: true,
					touchThreshold: 100,
					mobileFirst: true,
					responsive: this.options.responsive,
				});

				if (this.options.scrollTo !== null) {
					var self = this;
					this.$navigation.find("li").click(function() {
						var offset = $(this).offset().top;
						var scroll = $(window).scrollTop();

						if (scroll < offset) {
							$(window).scrollTo(self.$navigation, 500, {
								interrupt: true,
								offset: self.options.scrollTo,
							});
						}



					});
				}
			}
		},

		previous: function() {
			this.$content.slick("slickPrev");
		},

		next: function() {
			this.$content.slick("slickNext");
		},
	};

	//
	// Plugin methods
	//
	var methods = {
		// Initialize plugin
		init: function(options) {
			var setOptions = $.extend({}, defaultOptions, options);

			return this.each(function() {
				// Create for each element
				var timeliner = new Timeliner(this, setOptions);

				// Store instance into data attribute
				$(this).data("timelinerInstance", timeliner);

				// Ready
				timeliner.ready();
			});

        },

        prev: function() {
        	var timeliner = $(this).data("timelinerInstance");
        	timeliner.previous();
        },

        next: function() {
        	var timeliner = $(this).data("timelinerInstance");
        	timeliner.next();
        }
    };

	//
	// Plugin declaration
	//
	$.fn.timeliner = function(methodOrOptions)
	{
		if (methods[methodOrOptions]) {
			return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
		}
		else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            // Default to "init"
            return methods.init.apply(this, arguments);
        }
        else {
        	$.error("Method " +  methodOrOptions + " does not exist on jQuery.timeliner");
        }
    };

}(jQuery));